import Vue from 'vue';
const CustomEvent = new Vue();
export default CustomEvent;